module.exports = __webpack_public_path__ + "static/img/rencai_10.bbd3992b.jpg";